export const solicitacoesMenu = {
    name: 'Solicitações',
    url: '/appsebrae/consultorias/fornecedor/solicitacoes',
    icon: 'fa fa-book',
    regras: ['APPSE-FORN-CONS-00']
}

export const consultoriasMenu = {
    name: 'Consultorias',
    url: '/appsebrae/consultorias/fornecedor/consultorias',
    icon: 'fa fa-book',
    regras: ['APPSE-FORN-CONS-00']
}

export const pagamentosMenu = {
    name: 'Pagamentos',
    url: '/appsebrae/consultorias/fornecedor/pagamentos',
    icon: 'fa fa-dollar',
    regras: ['APPSE-FORN-PAG-00']
}
